export default "__VITE_ASSET__CtLBTKSD__"